module.exports = __webpack_public_path__ + "img/INTERIOR-SWIFT-2.565d26e3.jpg";